<template>
  <div class="d-flex flex-column align-items-center fade-in">
    <content-header-custom title="Search" :sub-title="subTitle" class="w-100 mxw-md px-10">
      <el-badge :value="cartCount" class="fs-20 mt-05 mr-05 pointer" @click.native="onCartClick">
        <i class="el-icon-shopping-cart-2"></i>
      </el-badge>
    </content-header-custom>
    <div class="main-content d-flex flex-column align-items-center">
      <el-row class="px-10 align-self-stretch" :gutter="10" id="search-input-section">
        <el-col :span="24" class="w-100 d-flex p-0">
          <el-input name="search" class="input-field" placeholder="Search here" v-model="criteria" @keyup.enter.native="search" v-on:input="debounceSearch">
            <div slot="prefix" class="d-flex align-items-center mr-20" style="color: #EF6563; cursor:pointer; width:100%; height:100%; padding: 0.35rem;" @click="search">
              <svg width="20" height="20" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.4167 18.2083C14.4437 18.2083 17.7083 14.9437 17.7083 10.9167C17.7083 6.88959 14.4437 3.625 10.4167 3.625C6.38959 3.625 3.125 6.88959 3.125 10.9167C3.125 14.9437 6.38959 18.2083 10.4167 18.2083Z" stroke="#EF6563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20.2385 20.7385L15.4766 15.9766" stroke="#EF6563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div slot="suffix" class="d-flex align-items-center" style="cursor:pointer; width:100%; height:100%" @click="filtersModalVisible = true">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12C7.10457 12 8 11.1046 8 10C8 8.89543 7.10457 8 6 8C4.89543 8 4 8.89543 4 10C4 11.1046 4.89543 12 6 12Z" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 4V8" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6 12V20" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 4V14" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18V20" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 9C19.1046 9 20 8.10457 20 7C20 5.89543 19.1046 5 18 5C16.8954 5 16 5.89543 16 7C16 8.10457 16.8954 9 18 9Z" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 4V5" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18 9V20" stroke="#152934" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </el-input>
        </el-col>
      </el-row>
      <el-row class="card-container mt-15 px-05 d-flex ">
        <template  v-for="(rego, idx) in sortedRegistration">
          <el-card class="box-card entity-card d-flex flex-column" shadow="never" :key="idx" v-if="checkProductVisibility(rego)">
            <div class="flex-1 align-items-center">
              <div class="flex-1 align-items-center ">
                <div class="event-heading">
                  <div class="outer d-flex flex-center mb-05">
                    <div class=" inner1 flex-0 d-flex align-items-center flex-center">
                      <el-image class="inner d-flex align-items-center flex-center"  :src="imageURL(rego._id, rego)">
                        <template v-slot:error>
                          <el-avatar class="d-flex flex-center bg-white align-items-center" shape="circle" :src="nationalId === 10 ? nationalLogoOnly: nationalLogoMark" :size="30"></el-avatar>
                        </template>
                      </el-image>
                    </div>
                  </div>
                  <div class="header-tag d-flex">
                    <div class="rego-type" v-if="(rego.registrationType === 'membership' ||rego.registrationType === 'event') && !rego.isClubMembership  ">{{ rego.registrationType | cap }}</div>
                    <div class="rego-type" v-if="rego.registrationType === 'membership'  && rego.isClubMembership ">Club</div>
                    <!-- <div v-if="['indv', 'indv-to-team'].includes(rego.productType)" class="member-style">{{ rego.memberType | cap }}</div> -->
                  </div>
                </div>
                <div class="event-info flex-1 d-flex flex-column my-10">
                  <div class="name f-bold ">{{ get(rego, 'products[0].name') || rego.name }}</div>
                  <div class="entity mb-05" >{{ rego.orgtree[rego.entityType].name }}</div>
                  <!-- <div class="entity mb-05" v-if="rego.isClubMembership">{{ rego.orgtree.association?  rego.orgtree.association.name : rego.orgtree.state? rego.orgtree.state.name : rego.orgtree.national.name    }}</div> -->
                  <div class="description">
                    <div class="title f-bold my-10 d-flex align-items-center" style="color: #919CAE" v-if="!rego.isClubMembership">Rego Type: <span class="member-style f-bold">{{ rego.productType | parseProductType }}</span></div>
                    <div v-if="['indv', 'indv-to-team'].includes(rego.productType)" class="title f-bold my-10 d-flex align-items-center" style="color: #919CAE">Join as: <span class="member-style f-bold">{{ rego.memberType | cap }}</span></div>
                    <span v-if=" rego.tags && rego.tags.length > 0" class="mt-10 mb-20 uppercase tags mr-10">
                      <span class="tag-items px-20 p-05 mr-05 my-05" v-for="t in rego.tags" :key="t._id">
                        {{ t.name }}
                        <span class="ribbon-tag "></span>
                        <span class="ribbon-cover"></span>
                        <span class="ribbon-curve"></span>
                        <span class="ribbon-button"></span>
                      </span>
                    </span>
                    <div v-if="['indv-to-team'].includes(rego.productType) && rego.team" class="title f-bold mb-05 ">Team: <span style="color: #919CAE" >{{ get(rego, 'team.name') | cap }}</span></div>
                    <!-- <div v-else-if="['indv-to-team'].includes(rego.productType) && rego.teams && rego.teams.length == 1" class="title f-bold mb-05 ">Team: <span style="color: #919CAE" >{{ get(rego, 'teams[0].name') | cap }}</span></div> -->
                    <div v-else-if="['indv-to-team'].includes(rego.productType) && rego.teams" class="title f-bold mb-05 ">
                      Team:
                      <span style="color: #919CAE" >
                        <!-- {{ get(rego, 'team.name') | cap }} -->
                        <el-select v-model="rego.selectedTeam" placeholder="Select" @change="getCapAndViceCap($event, rego)">
                          <el-option
                            v-for="team in filteredTeams(rego.teams)"
                            :key="team._id"
                            :label="team.name"
                            :value="team._id">
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                    <div v-if="rego.description" class="my-10 title f-bold" ><span class="description-text-limit" style="color: #919CAE">{{ rego.description }}</span></div>
                    <div v-if="rego.startDate && rego.endDate && !rego.useDuration" class="my-10"><span class="title f-bold">Duration:</span><span style="color: #919CAE" >{{ rego.startDate | formatDate }} - {{ rego.endDate | formatDate }}</span></div>
                    <div v-if="rego.useDuration" class="my-10"><span class="title f-bold">Duration:</span><span style="color: #919CAE" >{{ getDuration(rego) }}</span></div>
                    <div v-if="rego.expiry" class="my-10"><span class="title f-bold">Expiry Date:</span><span style="color: #919CAE" >{{ rego.expiry | formatDate }}</span></div>
                    <div style="display: flex; justify-content: space-between;" v-if="get(rego, 'meta.address.formatted')">
                      <div class="mb-10"><span class="title f-bold">Location:</span><span style="color: #919CAE">{{ rego.meta.address.formatted }}</span></div>
                      <div class="mb-10" v-if="get(rego, 'weather.base')" style="opacity: .7; display: flex; align-items: center; margin-top: auto; flex-shrink: 0">
                        <img height="25" style="margin-right: 3px; object-fit: cover;" :src="getWeatherIcon(rego.weather.base.icon)" />
                        <div class="temp">
                          <div style="font-size: 10px;">{{ Math.round(rego.weather.temperature, 0) }} °C</div>
                          <div style="font-size: 8px;">{{rego.weather.base.label}}</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="nationalId === 4 && rego.productType === 'indv-to-team'">
                      <div class="mb-10" v-if="trim(get(teamDetails[rego._id], 'captain.name')) ">
                        <span class="title f-bold">Captain:</span><span style="color: #919CAE">{{ teamDetails[rego._id].captain.name }} </span>
                        <el-tooltip effect="light" placement="top">
                          <div class="tooltip-content" slot="content" >
                            <span class="title f-bold">Email: </span><span style="color: #919CAE">{{ ( teamDetails[rego._id].captain.email) || '-' }} </span>
                            <br /><span class="title f-bold">Mobile: </span><span style="color: #919CAE">{{ ( teamDetails[rego._id].captain.mobile) || '-' }} </span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                      <div class="mb-10" v-if="trim(get(teamDetails[rego._id], 'viceCaptain.name')) ">
                        <span class="title f-bold">Vice Captain:</span><span style="color: #919CAE">{{ teamDetails[rego._id].viceCaptain.name }} </span>
                        <el-tooltip effect="light" placement="top">
                          <div class="tooltip-content" slot="content" >
                            <span class="title f-bold">Email: </span><span style="color: #919CAE">{{ (teamDetails[rego._id].viceCaptain.email) || '-' }} </span>
                            <br /><span class="title f-bold">Mobile: </span><span style="color: #919CAE">{{ (teamDetails[rego._id].viceCaptain.mobile) || '-' }} </span>
                          </div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="rego.products[0].isMembershipRequired">
              <span class="membership-notice">Membership Required </span>
              <el-tooltip effect="light" placement="top" v-if="rego.products[0].membershipProductsRequired.length">
                <div class="tooltip-content" slot="content">This event requires membership subscription
                  <br/>for all participants.
                  <br/> You are required to have one of the following memberships:
                  <ul style="padding-left: 1.5rem">
                    <span v-for="{name,_id, products} in rego.products[0].membershipProductsRequired" :key="products._id" >
                      <li>
                        <span v-if="products.memberType !== 'legacy-membership'" style="color: #1e1eaf; cursor:pointer" @click="handleMembershipClick(_id, products._id,rego)">
                          {{products.memberType}} - {{name}}
                        </span>
                        <span v-else>
                          {{products.memberType}}
                        </span>
                        <span v-if="products.tags && products.tags.length">
                          <span v-for="t in products.tags" :key="t._id">
                            <el-tag size="mini" class="ml-02" effect="plain">
                              {{t.name}}
                            </el-tag>
                          </span>
                        </span>
                      </li>
                    </span>
                  </ul>
                  To add this selection to your cart, please choose a pre-requisite membership option from the following list.</div>
                <i class="el-icon-info"></i>
              </el-tooltip>
              <el-tooltip effect="light" placement="top" v-else>
                <div class="tooltip-content" slot="content">This event requires membership subscription
                  <br/>for all participants.
                  <br/> At the moment, there is no required membership available for this event/membership
                  <br/> Or all required memberships are expired and not available for purchase.
                  <br/> Please contact your admin for further information.
                  </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
              </div>
            <div v-if="rego.products[0].isAccreditationRequired">
              <span class="membership-notice">Accreditation Required </span>
              <el-tooltip effect="light" placement="top">
                <div class="tooltip-content" slot="content" >This event requires accreditation(s)
                  <br/>for all participants.
                  <br/> You need to have the following accreditation(s):
                  <span v-for="{name, _id} in rego.products[0].accreditationProductsRequired" :key="_id" style="color: #1e1eaf;"> <br/> {{name}}</span>
                  <br/>Please click on register to check if you have
                  <br/> elegible members to register</div>
                  <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
            <div v-if="checkUpgradeElegible(rego)">
              <span class="membership-notice">Upgrade Eligible </span>
              <el-tooltip effect="light" placement="top">
                <div class="tooltip-content" slot="content">You can upgrade to this membership
                  <br/>using one of your existing membership.
                  <br/>
                  <br/><span style="color: #1e1eaf; cursor:pointer" @click="UpgradeDeRoute(rego)"> View More </span>
                </div>
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
            <div v-if="(
              !isExpired(rego.regoEndDate, rego.regoStartDate) &&
              !isExpired(rego.products[0].regoEndDate, rego.products[0].regoStartDate)
              && nationalId === 10)
              || (
                nationalId !== 10 && (rego.isClubMembership? rego.isClubMembershipRegoOpen :rego.isRegoOpen)
                && !isExpired(rego.regoEndDate, rego.regoStartDate)
                && rego.products[0].isRegoOpen)
              " class="event-btn d-flex justify-content-center flex-0">
              <el-button type="primary" class=" register" @click="initRegister(rego)">Register</el-button>
            </div>
            <div v-else-if="!(rego.isClubMembership? rego.isClubMembershipRegoOpen :rego.isRegoOpen) && rego.isWaitlistOpen" class="event-btn d-flex justify-content-center flex-0">
              <el-button type="primary" class="register" @click="waitlist(rego)">Join Waitlist</el-button>
            </div>
            <div v-else class="event-btn d-flex justify-content-center flex-0">
              <el-button type="primary" class=" closed-register" disabled>Registration is closed</el-button>
            </div>
          </el-card>
        </template>
      </el-row>
    </div>
    <el-dialog title="Filters" :visible.sync="filtersModalVisible" :close-on-click-modal="false">
      <el-form class="w-100">
        <el-row :gutter="10">
          <el-col :span="24" :md="8">
          <el-form-item label="Registration Type">
            <el-select v-model="filters.registrationTypes" placeholder="Select" class="w-100" multiple clearable>
              <el-option
                v-for="item in registrationTypes"
                :key="item.type"
                :label="item.text"
                :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
          <el-form-item label="Member Type">
            <el-select v-model="filters.memberTypes" placeholder="Select" multiple clearable class="w-100">
              <el-option
                v-for="item in memberTypes"
                :key="item.type"
                :label="item.name"
                :value="item.type">
              </el-option>
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
          <el-form-item label="Tags">
              <el-cascader
                class="w-100"
                :options="tags"
                :props="{ multiple: true}"
                @change="changeHandle"
                clearable></el-cascader>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="8">
            <el-form-item label="Organization:">
                  <el-select v-model="selectedOrganisationId"
                  ref="orgPicker"
                  @change="handleOrgChange"
                   clearable
                   filterable
                   :disabled="fixedOrganisation"
                   placeholder="Select">
                    <el-option-group
                      v-for="group in organisations"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item._id"
                        :label="item.name"
                        :value="item._id">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
         <el-button @click="filtersModalVisible = false">Close</el-button>
          <el-button @click="closeAndClearFilters">Clear & Close</el-button>
          <el-button type="primary" class="bg-highlight bd-0" @click="applyFilters">Apply</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Choose a member to register" :visible.sync="selectMemberModalVisible" :close-on-click-modal="false">
      <div class="d-flex flex-column flex-center w-100" v-if="selectMemberModalVisible">
        <div class="d-flex align-items-center mb-20 modal-entity-card">
          <div class="flex-0 d-flex align-items-center">
            <el-image style="width: 50px; height: 50px" :src="imageURL(selectedRego._id, selectedRego)">
              <template v-slot:error>
                <el-avatar class="d-flex flex-center fs-25 bg-lightblack" shape="square" icon="el-icon-picture" :size="50"></el-avatar>
              </template>
            </el-image>
          </div>
          <div class="flex-1 d-flex flex-column ml-15 event-info">
            <div class="name f-bold fs-15">{{ get(selectedRego, 'products[0].name', selectedRego.name) }}</div>
            <div class="entity">{{ selectedRego.orgtree[selectedRego.entityType].name }}</div>
            <div class="description">
              <div v-if="selectedRego.productType === 'indv'" class="mb-10 uppercase">Member Type: <span class="f-bold fs-15 c-highlight">{{ selectedRego.memberType | cap }}</span></div>
              <div v-if="selectedRego.productType === 'indv-to-team'" class="mb-10 uppercase">Member Type: <span class="f-bold fs-15 c-highlight">{{ selectedRego.memberType | cap }}</span></div>
            </div>
            <div class="d-flex flex-start break-word" v-if="selectedRego.products[0].isMembershipRequired || selectedRego.products[0].isAccreditationRequired">
              <span v-if="selectedRego.products[0].isMembershipRequired && !selectedRego.products[0].isAccreditationRequired">This event requires members subscription, only eligible members shown below.</span>
              <span v-if="selectedRego.products[0].isAccreditationRequired && !selectedRego.products[0].isMembershipRequired">This event requires accreditation(s), only eligible members shown below.</span>
              <span v-if="selectedRego.products[0].isMembershipRequired && selectedRego.products[0].isAccreditationRequired">This event requires members subscription & accreditation(s), only eligible members shown below.</span>
            </div>
          </div>
        </div>
        <member-board :productType="selectedRego.productType" :products="selectedRego.products" :rego="selectedRego" @select-member="selectMember" isRegister :animated="false" :disablePrimaryCheckbox="true" />
      </div>
    </el-dialog>
    <el-dialog title="Choose a member to join the waitlist" :visible.sync="waitlistModalVisible" :close-on-click-modal="false">
      <div class="d-flex flex-column flex-center w-100" v-if="waitlistModalVisible">
        <div class="d-flex align-items-center mb-20 modal-entity-card">
          <div class="flex-0 d-flex align-items-center">
            <el-image style="width: 50px; height: 50px" :src="imageURL(selectedRego._id, selectedRego)">
              <template v-slot:error>
                <el-avatar class="d-flex flex-center fs-25 bg-lightblack" shape="square" icon="el-icon-picture" :size="50"></el-avatar>
              </template>
            </el-image>
          </div>
          <div class="flex-1 d-flex flex-column ml-15 event-info">
            <div class="name f-bold fs-15">{{ get(selectedRego, 'products[0].name', selectedRego.name) }}</div>
            <div class="entity">{{ selectedRego.isClubMembership ? selectedRego.orgtree.association.name :selectedRego.orgtree[selectedRego.entityType].name }}</div>
            <div class="description">
              <div v-if="selectedRego.productType === 'indv'" class="mb-10 uppercase">Member Type: <span class="f-bold fs-15 c-highlight">{{ selectedRego.memberType | cap }}</span></div>
              <div v-if="selectedRego.productType === 'indv-to-team'" class="mb-10 uppercase">Member Type: <span class="f-bold fs-15 c-highlight">{{ selectedRego.memberType | cap }}</span></div>
            </div>
          </div>
        </div>
        <member-board :productType="selectedRego.productType" :products="selectedRego.products" :rego="selectedRego" @select-member="selectMemberForWaitlist" isRegister :animated="false" :disablePrimaryCheckbox="true" />
      </div>
    </el-dialog>
    <el-dialog
      :title="getTitle"
      :visible.sync="clearanceDialogVisible"
      width="30%"
      >
      <div class="d-flex flex-column " v-if="!memberClearanceRequest">
        <span class="break-word">You are already registered to another club as a player, you need to request a clearance to be able to continue.</span>
        <div class="mt-10">
          <el-input-title >Reason</el-input-title>
          <el-input placeholder="Type your reason here" v-model="clearanceRequest.reason" ></el-input>
        </div>
      </div>
      <div class="d-flex flex-column " v-if="memberClearanceRequest && memberClearanceRequest.status ==='Pending'">
        <span>Registration clearance has been submmited. Please contact your Club or Association for further information.</span>
      </div>
      <div class="d-flex flex-column w-100" v-if="memberClearanceRequest && memberClearanceRequest.status ==='Declined'">
      <span>Registration clearance has been denied. Please contact your Club or  Association for further information.</span>
      <span>If you would like to request another clearance, please click Request another clearance button below.</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearanceDialogVisible = false , clearanceRequest.reason= '' ">Cancel</el-button>
        <el-button type="primary" v-if="!memberClearanceRequest " @click="handleRequestClearances">Request Clearance</el-button>
        <el-button type="primary" v-if="memberClearanceRequest && memberClearanceRequest.status ==='Declined'" @click="handleRequestClearances">Request Another Clearance</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="membershipRequiredDialog"
      title="Membership Required"
      :visible.sync="membershipRequiredDialog"
      width="30%"
      >
      <div class="d-flex flex-column">
        <el-alert
          title="Membership Required"
          type="warning"
          description="This event requires membership subscription
          for all participants."
          show-icon>
        </el-alert>
        <div v-if="selectedRego.products[0].membershipProductsRequired.length" >
                    <br/> You are required to have one of the following memberships:
                    <ul style="padding-left: 1.5rem">
                      <span v-for="{name,_id, products} in selectedRego.products[0].membershipProductsRequired" :key="products._id" >
                        <li>
                          <span v-if="products.memberType !== 'legacy-membership'" style="color: #1e1eaf; cursor:pointer" @click="handleMembershipClick(_id, products._id,selectedRego)">
                            {{products.memberType}} - {{name}}
                          </span>
                          <span v-else>
                            {{products.memberType}}
                          </span>
                          <span v-if="products.tags && products.tags.length">
                            <span v-for="t in products.tags" :key="t._id">
                              <el-tag size="mini" class="ml-02" effect="plain">
                                {{t.name}}
                              </el-tag>
                            </span>
                          </span>
                        </li>
                      </span>
                    </ul>
                    To add this selection to your cart, please choose a pre-requisite membership option from the following list.
                  </div>
                <div v-else>
                  <br/> This event requires membership subscription for all participants.
                  <br/> At the moment, there is no required membership available for this event/membership
                  <br/> Or all required memberships are expired and not available for purchase.
                  <br/> Please contact your admin for further information.
                  </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="`${get(selectedRego, 'name')}`"
      :visible.sync="familyMSDialog"
      width="30%"
      >
      <div style=" overflow-x: auto;">
        <el-table
          style="width: 100%"
          :data="familyMSList">
          <el-table-column
            prop="gender"
            label="Gender"
            width="100">
          </el-table-column>
          <el-table-column
            label="Member Type"
            width="120">
            <template v-slot="scope">
              {{ scope.row.memberType | cap }}
            </template>
          </el-table-column>
          <el-table-column
            prop="ageFrom"
            label="Age From"
            width="100">
          </el-table-column>
          <el-table-column
            prop="ageTo"
            label="Age To"
            width="100">
          </el-table-column>
          <el-table-column width="200" label="Member">
            <template v-slot="scope">
              <el-select v-model="scope.row.memberId" placeholder="Select Member">
                <el-option v-for="e in scope.row.availableMembers" :label="`${e.profile.firstName} ${e.profile.lastName}`" :key="e._id" :value="e._id" />
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <div class="member-btn d-flex justify-content-center flex-0 mt-15">
            <el-button @click="cancelFamilyRego" >Cancel</el-button>
            <el-button :disabled="!selectedMember" type="primary" class="color-highlight bd-0" @click="initRegoFamily(familyMSList)">Register</el-button>
          </div>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog
      title="Password Required"
      :visible.sync="showAuthProduct"
      width="30%"
      >
      <el-form class="w-100" :model="product" :rules="passwordRules" ref="productPassForm">
        <el-row :gutter="10">
          <el-col :span="18" :md="18">
            Password required to enter this event, do you want to request a password?
          </el-col>
          <el-col :span="24" :md="24" class="mt-05">
            <el-button @click="requestAccess">Request Password</el-button>
          </el-col>
          <el-col :span="24" :md="24">
            <el-form-item prop="password" label="Password">
              <el-input type="password" v-model="product.password" />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="errorMessage">
            <el-alert show-icon type="error" :title="errorMessage" :closable="false" />
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAuthProduct = false">Cancel</el-button>
        <el-button type="primary" @click="authProduct">Submit</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="showTeamSelect" title="Select Team" :visible.sync="showTeamSelect">
      <div class="break-word">Please select or search for your team from the list to register </div>
      <div class="search-bar-team">
        <el-input class="input-field" placeholder="Search by team name or ID" v-model="teamKeyword"
          @keyup.enter.native="searchTeam">
          <!-- <div slot="prefix" class="d-flex align-items-center mr-20" style="cursor:pointer; height:100%; padding: 0.35rem;" @click="search">
                  <i class="el-icon-search"></i>
                </div> -->
          <el-button slot="suffix" icon="el-icon-search" size="small" @click="searchTeam">
          </el-button>
        </el-input>
      </div>
      <div class="add-new-team">
        <!-- add a line say "Can't find your team? Add a new team" -->
        <div class="mt-10">
          Can’t find your team on this list? Try searching for it. Or
          <span>
            <el-button class="register-button" type="text" size="medium" @click="createNewTeam()">
              Create a new team</el-button>
          </span>
        </div>

      </div>
      <!-- take form selectedRego.products[0].membershipProductsRequired -->
      <el-table class="item-table " :border="true" highlight-current-row stripe max-height="500"
        :data="allTeams">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!-- display in legend style -->
            <fieldset>
              <legend>Team Details</legend>
              <div class="break-word">
                {{getOrgtree(props.row) }}
              </div>
              <div>
                Created At: {{moment(props.row.createdAt).format('DD/MM/YYYY')}}
              </div>
              <div>
                Created By: {{get(props, 'row.createdBy[0].profile.firstName','N/A')}}
                {{get(props, 'row.createdBy[0].profile.lastName')}}
              </div>
            </fieldset>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" min-width="300">
        </el-table-column>
        <!-- column to indicate your team -->
        <el-table-column prop="isMyTeam" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.isMyTeam">
              Your Team
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Operation" width="110">
          <template slot-scope="scope">
            <el-button class="register-button" type="select" size="mini"
              @click="registerTeam(scope.row)">Select</el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showTeamSelect = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable global-require */
import _ from 'lodash';
import moment from 'moment-timezone';
import { weatherCodes } from '@/utils/constants';
import { calculateMemberAge } from '@/utils/helpers';
import MemberBoard from '../../components/members/MemberBoard.vue';

const fetchWeather = (registrations) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const rego of registrations) {
    if (_.get(rego, 'weather.weatherCode')) {
      rego.weather.base = _.find(weatherCodes, (c) => c.value === _.get(rego, 'weather.weatherCode')) || {};
    }
  }
  return registrations;
};

const doSearch = (self, criteria, filters = {}, entity = {}) => {
  self.$store.commit('loading', { loading: true, text: 'Loading...' });
  const { entityId, member } = self;
  const endOfYear = self.$store.getters['national/endOfYear'];
  if (entityId) { _.assign(filters, { eventId: entityId }); }
  if (member && member.profile.dob) { _.assign(filters, { age: calculateMemberAge(member.profile.dob, endOfYear) }); }
  if (member && member.profile.gender) { _.assign(filters, { gender: member.profile.gender }); }
  self.$http.post('/assemble/api/v1/portal/registrations/search', {
    criteria: _.trim(criteria),
    filters,
    entity
  }).then(async (res) => {
    const { result, transactionFee } = res.data.data;
    // eslint-disable-next-line no-param-reassign
    self.registrations = fetchWeather(result);
    // eslint-disable-next-line no-param-reassign
    self.teamDetails = {};
    self.$store.commit('cart/setTransactionFee', transactionFee);
    self.$store.commit('loading', false);
  }).catch((e) => {
    self.$message.error(e.response.data.message);
    self.$store.commit('loading', false);
  });
};

// const doSearchByMembership = (self, criteria, filters = {}) => {
//   self.$store.commit('loading', { loading: true, text: 'Loading...' });
//   const { entityId } = self;
//   if (entityId) { _.assign(filters, { eventId: entityId }); }
//   self.$http.post('/assemble/api/v1/portal/registrations/search/memberships', {
//     criteria,
//     filters
//   }).then(async (res) => {
//     const { result, transactionFee } = res.data.data;
//     // eslint-disable-next-line no-param-reassign
//     self.registrations = fetchWeather(result);
//     self.$store.commit('cart/setTransactionFee', transactionFee);
//     self.$store.commit('loading', false);
//   }).catch((e) => {
//     self.$message.error(e.response.data.message);
//     self.$store.commit('loading', false);
//   });
// };

const doSearchByProduct = (self) => {
  const {
    $store, $http, $message, entityId, productId
  } = self;
  $store.commit('loading', { loading: true, text: 'Loading...' });
  $http.post(`/assemble/api/v1/portal/registrations/search/entities/${entityId}/products/${productId}`)
    .then((res) => {
      const { result, transactionFee } = res.data.data;
      // eslint-disable-next-line no-param-reassign
      self.registrations = result;
      $store.commit('cart/setTransactionFee', transactionFee);
      $store.commit('loading', false);
    }).catch((e) => {
      $message.error(e.response.data.message);
      $store.commit('loading', false);
    });
};

export default {
  name: 'Finder',
  components: {
    MemberBoard
  },
  props: {
    id: String,
    name: String,
    defaultCriteria: String,
    memberId: Number,
    productId: String,
    password: String,
    entityId: String,
  },
  data() {
    return {
      showTeamSelect: false,
      allTeams: [],
      teamKeyword: '',
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      defaultEntity: {
        name: 'national',
        _id: +process.env.VUE_APP_NATIONAL_ID
      },
      subTitle: 'Find your membership, team or event by name',
      criteria: '',
      clearanceRequest: {
        reason: undefined
      },
      registrations: [],
      selectedRego: undefined,
      selectMemberModalVisible: false,
      membershipRequiredDialog: false,
      waitlistModalVisible: false,
      filtersModalVisible: false,
      clearanceDialogVisible: false,
      clearanceDeclinedDialogVisible: false,
      member: undefined,
      memberMembership: undefined,
      formattedMembership: undefined,
      pageNum: 0,
      memberID: undefined,
      teamDetails: {},
      memberTypes: [],
      canUpgradeFromMembership: [],
      tags: [],
      selectedOrganisationId: undefined,
      registrationTypes: [
        {
          text: 'Individual',
          type: 'indv'
        },
        {
          text: 'Team',
          type: 'team'
        },
        {
          text: 'Individual To Team',
          type: 'indv-to-team'
        }],
      organisations: [
        {
          label: 'State',
          options: [],
        },
        {
          label: 'Association',
          options: [],
        },
        {
          label: 'Club',
          options: [],
        },
      ],
      filters: {
        memberTypes: [],
        registrationTypes: [],
        tags: [],
        organisation: {
          level: undefined,
          _id: undefined
        }
      },
      memberClearanceRequest: undefined,
      fixedOrganisation: false,
      familyMSDialog: false,
      familyMSList: [],
      selectedFamilyMS: undefined,
      members: [],
      showAuthProduct: false,
      errorMessage: undefined,
      product: {
        password: undefined,
      },
      passwordRules: {
        password: [
          { required: true, message: 'Password is required', trigger: 'blur' }
        ]
      },
    };
  },
  async mounted() {
    // Scroll to top on mobile devices
    this.$nextTick(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    });

    const resMembers = await this.$http.get('/assemble/api/v1/account/portal/members-with-registrations');
    this.members = resMembers.data.data;
    console.log(this.members, 'xxxx');
    // get member if memberId is passed from dashboard...
    const pref = await this.$http.get('assemble/api/v1/portal/nationals/get/payment-preference');
    if (pref.data.data) {
      console.log('Updating payment settings...');
      this.$store.commit('national/updatePaymentPref', pref.data.data);
    }
    await this.getOrganisations();
    const storedOrganisation = this.$store.getters['national/getOrganisation'];
    if (storedOrganisation?._id) {
      this.filters.organisation._id = storedOrganisation._id;
      this.filters.organisation.level = _.capitalize(storedOrganisation.level);
      if (this.personalise) this.personalise.organisationId = _.get(storedOrganisation, '_id');
      if (this.filters.organisation.level !== 'national') {
        this.fixedOrganisation = true;
      }
    }
    if (this.memberId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      Promise.all([
        this.getMemberMembership(this.memberId),
        this.$http.get(`/assemble/api/v1/account/portal/members/${this.memberId}`),
        this.getMemberTypes(),
        this.getTagGroups()
      ])
        .then(([resMemberMembership, resMember]) => {
          this.member = resMember.data.data;
          this.memberMembership = resMemberMembership.data.data;
        }).catch((error) => {
          this.$message.error(error.response.data.message);
        });
    } else {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      Promise.all([this.getMemberTypes(), this.getTagGroups()])
        .then(() => {})
        .catch(() => {});
    }
    const defaultEntity = this.$store.getters['national/getEntity'] || {};
    if (defaultEntity && defaultEntity._id) {
      this.defaultEntity = defaultEntity;
    }
    if (this.defaultCriteria) {
      this.criteria = this.defaultCriteria;

      doSearch(this, this.criteria, {}, defaultEntity);
    }

    if (this.id || this.name) {
      this.criteria = this.id || this.name;
      doSearch(this, this.criteria, {}, defaultEntity);
    }
    console.log(this.entityId, 'this.entityId');
    console.log(this.productId, 'this.productId');

    if (this.entityId && this.productId) {
      doSearchByProduct(this);
    }

    if (this.$route.query.entityId && !this.$route.query.productId) {
      this.criteria = this.$route.query.entityId;
      if (!this.id) doSearch(this, this.criteria, {}, defaultEntity);
    }

    if (!this.id && !this.name && !this.entityId && !this.productId) {
      doSearch(this, this.criteria, {}, defaultEntity);
    }
  },
  methods: {
    filteredTeams(teams) {
      console.log(teams, 'teams');
      console.log(this.id, 'this.id');
      if (this.id) {
        return teams.filter((team) => team._id === +this.id);
      }

      return teams;
    },
    getDuration(rego) {
      const { durationYear, durationMonth, durationDay } = rego;
      const today = moment();
      const end = moment().add(durationYear, 'years').add(durationMonth, 'months').add(durationDay, 'days');
      return `${today.format('DD MMM YYYY')} - ${end.format('DD MMM YYYY')}`;
    },
    cancelFamilyRego() {
      _.each(this.familyMSList, (fam) => {
        // eslint-disable-next-line no-param-reassign
        fam.memberId = undefined;
      });
      this.familyMSDialog = false;
      this.selectedFamilyMember = false;
    },
    initRegoFamily(familyProduct) {
      const mappedFamilyRego = _.map(familyProduct, (fp) => ({
        ...this.selectedRego,
        ...fp,
        _id: this.selectedRego._id,
        gender: fp.gender,
        ageFrom: fp.ageFrom,
        ageTo: fp.ageTo,
        memberType: fp.memberType,
        productId: _.get(this, 'selectedRego.products[0]._id'),
        products: [
          {
            ...this.selectedRego.products[0],
            gender: fp.gender,
            ageFrom: fp.ageFrom,
            ageTo: fp.ageTo,
            memberType: fp.memberType,
            familyProductId: fp._id,
          }
        ]
      }));

      console.log(mappedFamilyRego, 'mappedFamilyRego');

      this.selectedRego.familyRego = mappedFamilyRego;

      this.selectedFamilyMember = true;
      this.register(this.selectedRego);
    },
    async requestAccess() {
      const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/request-password', {
        userId: this.userId,
        productId: this.selectedRego.products[0]._id
      });
      if (res.data.data) this.$message.success('Request sent successfully!');
    },
    async authProduct() {
      const rego = this.selectedRego;
      const { password } = this.product;
      this.errorMessage = '';
      this.$refs.productPassForm.validate(async (valid) => {
        if (valid) {
          const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/auth', {
            password,
            productId: rego.products[0]._id
          });
          if (res.data.data) {
            this.register(rego);
            return true;
          }
          this.errorMessage = 'Invalid password';
          return false;
        }
        return false;
      });
    },
    checkProductVisibility(rego) {
      const product = rego.products[0];
      if (this.entityId && this.productId) return true;
      if (_.get(product, 'isPrivate')) {
        if (product.isVisible !== undefined) {
          if (product.isVisible) return true;
          return false;
        }
      }
      return true;
    },
    async initRegister(rego) {
      this.selectedRego = rego;
      if (_.get(rego, 'products[0].isPrivate')) {
        if (this.password) {
          try {
            const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/password-decrypt', {
              productId: rego.products[0]._id,
              password: this.password
            });
            this.product.password = res.data.data;
            const auth = await this.$http.post('/assemble/api/v1/portal/registrations/product/auth', {
              password: this.product.password,
              productId: rego.products[0]._id
            });
            if (auth.data.data) {
              this.register(rego);
              return true;
            }
          } catch (e) {
            console.log(e);
            this.showAuthProduct = true;
          }
        }
        this.showAuthProduct = true;
      } else this.register(rego);

      return false;
    },
    // async initRegister(rego) {
    //   this.selectedRego = rego;
    //   console.log('selectedRego', this.selectedRego);
    //   if (_.get(rego, 'resultOptions.isPrivate')) {
    //     if (this.password) {
    //       const res = await this.$http.post('/assemble/api/v1/portal/registrations/product/password-decrypt', {
    //         productId: rego.products[0]._id,
    //         password: this.password
    //       });
    //       this.product.password = res.data.data;
    //     }
    //     this.showAuthProduct = true;
    //   } else this.register(rego);
    // },
    showFullProductName(message) {
      this.$alert(message, 'Register', {
        confirmButtonText: 'OK',
        customClass: 'product-name-alert',
        dangerouslyUseHTMLString: true,
        showClose: false,
        center: true,
      });
    },
    handleOrgChange(value) {
      if (value) {
        const organisation = this.organisations.find((group) => group.options.find((org) => org._id === value));
        if (organisation) {
          _.assign(this.filters.organisation, {
            level: organisation.label,
            _id: value,
          });
        }
      } else {
        this.filters.organisation = {
          _id: undefined,
          level: undefined,
        };
      }
    },
    isExpired(endDate, startDate) {
      if (endDate) {
        const nationalId = +process.env.VUE_APP_NATIONAL_ID;
        const timenow = moment.tz(this.timezone);

        const currentDate = moment.tz(this.timezone);
        const regoStartDate = moment(startDate);
        const regoEndDate = moment(endDate);

        const cDate = new Date(currentDate.format('YYYY-MM-DD, h:mm:ss a'));
        const sDate = new Date(regoStartDate.format('YYYY-MM-DD, h:mm:ss a'));
        const eDate = new Date(regoEndDate.format('YYYY-MM-DD, h:mm:ss a'));

        const cutoff = nationalId === 10
          ? regoEndDate
            .hour(18)
            .minute(0)
            .second(0)
            .millisecond(0)
          : regoEndDate;

        const checkDate = currentDate >= regoStartDate && currentDate <= regoEndDate;
        // console.log({ checkDate });

        // console.log(this.timezone);
        // console.log(moment().format('YYYY-MM-DD, h:mm:ss a'));
        // console.log(cDate);
        // console.log(sDate);
        // console.log(eDate);
        // console.log('-------------');

        console.log({
          cutoff: cutoff.valueOf(),
          timenow: timenow.valueOf(),
          cutoffGreater: cutoff > timenow,
          cDate,
          sDate,
          eDate,
          currentDate,
          regoStartDate,
          regoEndDate,
        });

        if (!checkDate) return true;
        console.log('returning cutoff > timenow');
        if (cutoff > timenow) return false;

        console.log('returning false');
        return false;
      }
      console.log('returning false 2');
      return false;
    },
    getWeatherIcon(name) {
      // eslint-disable-next-line global-require
      // eslint-disable-next-line import/no-dynamic-require
      return require(`@/assets/weather-icons/${name}.svg`);
    },
    async getOrganisations() {
      const stateResponse = await this.$http.get('/assemble/api/v1/portal/nationals/states');
      const assocResponse = await this.$http.get('/assemble/api/v1/portal/nationals/associations');
      const clubResponse = await this.$http.get('/assemble/api/v1/portal/nationals/clubs');
      this.organisations[0].options = stateResponse.data.data;
      this.organisations[1].options = assocResponse.data.data;
      this.organisations[2].options = clubResponse.data.data;
    },
    handleRequestClearances() {
      const { _id, entityId, memberType } = this.selectedRego;
      _.assign(this.clearanceRequest, {
        _id,
        entityId,
        memberId: this.memberID,
        memberType
      });
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post('/assemble/api/v1/portal/regoclearances', this.clearanceRequest)
        .then(() => {
          this.$store.commit('loading', false);
          this.$message.success('Request submitted successfully');
          const pathName = this.hasCustomEntity ? 'custom-dashboard' : 'dashboard';
          this.$router.push({ name: pathName });
        })
        .catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
      this.clearanceDialogVisible = false;
      this.clearanceDeclinedDialogVisible = false;
    },
    async getMemberTypes() {
      const response = await this.$http.get('/assemble/api/v1/portal/nationals/member-types');
      this.memberTypes = response.data.data;
    },
    async getMemberMembership(memberId) {
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${memberId}`);
      return response;
    },

    async checkRequestClearances(memberId) {
      const { entityId } = this.selectedRego;
      const response = await this.$http.get(`/assemble/api/v1/portal/club/${entityId}/member/${memberId}/regoclearances`);
      const [result] = response.data.data;
      if (result) {
        this.memberClearanceRequest = result;
        if (this.memberClearanceRequest.status === 'Approved') {
          const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedMembership: this.selectedRego },
          });
        }
        this.clearanceDialogVisible = true;
      } else {
        this.clearanceDialogVisible = true;
      }
    },
    async getTagGroups() {
      const response = await this.$http.get('/assemble/api/v1/portal/tags');
      // const activeEntity = this.$store.getters['national/getEntity'];
      // let url = '';

      // if (activeEntity && _.get(activeEntity, 'level') === 'club') url = `/assemble/api/v1/portal/tags/${_.get(activeEntity, 'level')}/${_.get(activeEntity, '_id')}`;
      // else url = '/assemble/api/v1/portal/tags';

      // const response = await this.$http.get(url);
      let tagsData = response.data.data;
      tagsData = this.reducedTagsData(tagsData);
      this.tags = [...this.tags, ...tagsData];
    },
    reducedTagsData(tagsData) {
      return _.reduce(tagsData, (tags, tag) => {
        tags.push({ value: tag._id, label: tag.name });
        return _.orderBy(tags, ['label'], 'asc');
      }, []);
    },
    changeHandle(value) {
      const flattenTags = _.flatten(_.map(value, (i) => i));
      this.filters.tags = [...flattenTags];
    },
    imageURL(regoId, rego) {
      console.log('rego for imgurl', rego);
      return _.get(rego, 'meta.imgUrl');
    },
    search() {
      doSearch(this, this.criteria, {}, this.defaultEntity);
    },
    // eslint-disable-next-line func-names
    debounceSearch: _.debounce(function (query) {
      if (query && query.length < 3) return;
      doSearch(this, this.criteria, {}, this.defaultEntity);
    }, 500),
    UpgradeDeRoute(rego) {
      this.$router.push({
        name: 'profile',
        params: {
          tabName: 'rego-history', id: this.memberId, regoId: rego._id, regoProductId: rego.products[0]._id
        }
      });
    },
    handleMembershipClick(id, productId, rego) {
      this.$store.commit('cart/setPendingRequiredRego', rego);
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post(`/assemble/api/v1/portal/registrations/search/entities/${id}/products/${productId}`)
        .then((res) => {
          const { result, transactionFee } = res.data.data;
          // eslint-disable-next-line no-param-reassign
          this.registrations = result;
          this.membershipRequiredDialog = false;
          this.$store.commit('cart/setTransactionFee', transactionFee);
          this.$store.commit('loading', false);
        }).catch((e) => {
          this.$message.error(e.response.data.message);
          this.$store.commit('loading', false);
        });
    },

    async searchTeam() {
      this.$store.commit('loading', true, 'Loading teams...');
      // this.$store.commit('loadingText', 'Loading teams...');
      const res = await this.$http.post('/assemble/api/v1/portal/teams/search-entity', {
        teamKeyword: this.teamKeyword,
      });
      this.$store.commit('loading', false);

      const resTeam = res.data.data;
      // get user ID
      const userId = this.$store.getters['user/userId'];
      // sort by user's team first
      const userTeams = resTeam.filter((t) => t.createdBy.length && t.createdBy[0]._id === userId);
      // add flag to indicate user's team
      userTeams.forEach((t) => {
        // eslint-disable-next-line no-param-reassign
        t.isMyTeam = true;
      });
      const otherTeams = resTeam.filter((t) => !t.createdBy.length || t.createdBy[0]._id !== userId);

      this.allTeams = userTeams.concat(otherTeams);
    },
    registerTeam(team) {
      this.showTeamSelect = false;
      if (team && team._id) {
        _.assign(this.selectedRego, { team });
      }
      const pathName = this.hasCustomEntity ? 'custom-event-register-team' : 'event-register-team';
      this.$router.push({
        name: pathName,
        params: { criteria: this.criteria, selectedEvent: this.selectedRego },
      });
    },
    async register(rego) {
      this.selectedRego = rego;
      if (rego.products[0].familyMS && rego.products[0].familyMS.length && !this.selectedFamilyMember) {
        this.checkFamily(rego);
        return false;
      }
      const { entityType, entityCustomDateCutoff } = this.selectedRego;
      console.log('selectedRegoss', this.selectedRego);
      // check team is selected in case of indv-to-team
      if (rego.productType === 'indv-to-team' && rego.teams && !rego.selectedTeam) { return this.$message.error('Please select a team to register.'); }
      if (this.selectedRego.productType === 'team') {
        // await this.searchTeam();
        // this.showTeamSelect = true;
        const pathName = this.hasCustomEntity ? 'custom-event-register-team' : 'event-register-team';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedEvent: this.selectedRego, member: this.member },
        });
      } else if (rego.productType === 'family') {
        this.$store.commit('loading', false);
        const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
        this.$router.push({
          name: pathName,
          params: { criteria: this.criteria, selectedMembership: this.selectedRego },
        });
      } else if (this.memberId && _.get(this.member, 'profile.dob')) {
        // check if member is already registered for this product
        console.log('this.memberMembership', this.memberMembership);
        console.log('this.memberId', this.memberId);
        console.log('this.selectedRego', this.selectedRego);
        const isRegistered = this.memberMembership.find((m) => m.productId === rego.products[0]._id && m.memberId === this.memberId && m.entityId === rego._id && !m.deregistered);
        console.log('isRegistered', isRegistered);
        if (isRegistered && isRegistered.payAfter && !isRegistered.payAfterMeta.fullyPaid) {
          console.log('isRegistered.payAfterMeta.fullyPaid', isRegistered.payAfterMeta.fullyPaid);
          console.log('isRegistered.payAfter', isRegistered);
          return this.$router.push({ name: 'partial-payment', params: { id: isRegistered._id } });
        }
        if (isRegistered && isRegistered.payAfter && isRegistered.payAfterMeta.fullyPaid) {
          return this.$message.error('You are already registered for this product');
        }
        if (isRegistered && !isRegistered.payAfter) {
          return this.$message.error('You are already registered for this product');
        }
        // if user selected member in dashboard to register
        let endOfYear = this.$store.getters['national/endOfYear'];
        if (entityType !== 'national' && entityCustomDateCutoff && entityCustomDateCutoff.useCustomDateCutoff) {
          const { customDateCutoffMonth, customDateCutoffDay } = entityCustomDateCutoff;
          endOfYear = `${moment().year()}-${customDateCutoffMonth}-${customDateCutoffDay}`;
        }
        const age = calculateMemberAge(this.member.profile.dob, endOfYear);
        const validProduct = _.find(rego.products, (p) => age >= p.ageFrom && age <= p.ageTo && (p.gender === this.member.profile.gender || p.gender === 'All' || !p.gender || (p.gender === 'Other' && (this.member.profile.gender !== 'Male' || this.member.profile.gender !== 'Female'))));
        if (!validProduct) {
          return this.$message.error('Unfortunately the member you selected doesn\'t meet the registration criteria');
        }
        if (rego.products.find((p) => p.isMembershipRequired)) {
          const foundMemberships = rego.products[0].membershipProductsRequired
            .reduce((updatedMembership, pr) => {
              let foundRequiredMS = [];
              if (pr.products.tags && pr.products.tags.length) {
                const tagArray = pr.products.tags;
                foundRequiredMS = this.memberMembership
                  .filter((m) => (_.get(m, 'regoEntity.products.tags', []).length === tagArray.length)
                    && _.get(m, 'regoEntity.products.tags', []).length
                    && m.regoEntity.products.tags.every((tag, index) => tag._id === tagArray[index]._id)
                    && pr._id === m.entityId && pr.products.type === m.productType && pr.products.memberType === m.memberType && m.expired !== true);
              } else {
                foundRequiredMS = this.memberMembership
                  .filter((m) => rego.products[0].membershipProductsRequired.some((p) => p._id === m.entityId
                    && p.products.type === m.productType
                    && p.products.memberType === m.memberType
                    && m.expired !== true));
              }
              return updatedMembership.concat(foundRequiredMS);
            }, []);

          const storeRegos = this.$store.state.cart.registrations;
          const memberStoreRegos = storeRegos.filter((r) => r.memberId === this.memberId);
          const foundIntentToBuy = rego.products[0].membershipProductsRequired
            .reduce((updatedMembership, pr) => {
              let foundRequiredMS = [];
              if (pr.products.tags && pr.products.tags.length) {
                const tagArray = pr.products.tags;
                foundRequiredMS = memberStoreRegos
                  .filter((m) => (_.get(m, 'regoEntity.products.tags', []).length === tagArray.length)
                    && _.get(m, 'regoEntity.products.tags', []).length
                    && m.regoEntity.products.tags.every((tag, index) => tag._id === tagArray[index]._id)
                    && pr._id === m.entityId && pr.products.type === m.productType && pr.products.memberType === m.memberType && m.expired !== true);
              } else {
                foundRequiredMS = memberStoreRegos
                  .filter((m) => rego.products[0].membershipProductsRequired.some((p) => p._id === m.entityId
                    && p.products.type === m.productType
                    && p.products.memberType === m.memberType
                    && m.expired !== true));
              }
              return updatedMembership.concat(foundRequiredMS);
            }, []);

          // const membershipIds = _.uniq(_.map(rego.products[0].membershipProductsRequired, '_id'));
          // const productIds = _.uniq(_.map(rego.products[0].membershipProductsRequired, 'products._id'));
          if (!foundMemberships.length && !foundIntentToBuy.length) {
            this.membershipRequiredDialog = true;
            return false;
          }
        }
        if (rego.products.find((p) => p.isAccreditationRequired)) {
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          const accreditationIds = _.map(_.get(rego, 'products[0].accreditationProductsRequired', []), (a) => a._id);
          const outerThis = this;
          this.$http.post('/assemble/api/v1/portal/registrations/member-accreditations', { accreditationIds }) // eslint-disable-next-line
            .then((res) => {
              this.$store.commit('loading', false);
              const accredMemberIds = res.data.data;
              if (!_.includes(accredMemberIds, outerThis.memberId)) return outerThis.$message.error('Accreditation is required to join this event');
              outerThis.selectMember(this.memberId);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        } else this.selectMember(this.memberId);
      } else {
        console.log('this.memberId', this.memberId);
        this.selectMemberModalVisible = true;
      }
      return true;
    },
    waitlist(rego) {
      console.log(rego);
      this.selectedRego = rego;
      this.waitlistModalVisible = true;
    },
    async selectMemberForWaitlist(memberId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.memberID = memberId;
      this.$http.post('/assemble/api/v1/portal/waitlist', {
        eventId: this.selectedRego._id,
        entityId: this.selectedRego._id,
        type: this.selectedRego.registrationType,
        memberId,
        productId: this.selectedRego.products[0]._id,
      }).then((res) => {
        this.$store.commit('loading', false);
        this.$message.success(res.data.message);
        this.waitlistModalVisible = false;
      }).catch((e) => {
        this.$store.commit('loading', false);
        this.$message.error(e.response.data.message);
      });
    },
    async selectMember(memberId) {
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.memberID = memberId;
      // Verify if eventId, memberId and memberType exists
      const registrations = this.$store.getters['cart/registrations'];

      if (this.selectedRego.registrationType === 'event') {
        const {
          _id: entityId, productType, memberType, tags, ageFrom, ageTo
        } = this.selectedRego;

        const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.memberType === memberType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && _.isEqual(r.tags, tags));
        if (foundRego && productType !== 'indv-to-team') {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        if (foundRego && productType === 'indv-to-team') {
          const currentTeamId = this.selectedRego.selectedTeam;
          const foundTeam = _.find(registrations, (t) => t.team && t.team._id === currentTeamId);
          if (foundTeam) {
            this.$store.commit('loading', false);
            return this.$message.error('Registration for this member has already been added to cart.');
          }
        }

        if (this.selectedRego.productType === 'indv') {
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.selectedRego },
          });
        } else if (this.selectedRego.productType === 'indv-to-team') {
          if (this.selectedRego.teams) {
            const team = this.selectedRego.teams.find((item) => item._id === this.selectedRego.selectedTeam);
            _.assign(this.selectedRego, { team });
            delete this.selectedRego.teams;
            delete this.selectedRego.selectedTeam;
          }
          this.$store.commit('loading', false);
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
          this.$router.push({
            name: pathName,
            params: { criteria: this.criteria, memberId, selectedEvent: this.selectedRego },
          });
        } else {
          this.$store.commit('loading', false);
          this.$message.error('Registration for this product type is not available yet.');
        }
      } else if (this.selectedRego.registrationType === 'membership') {
        const {
          _id: entityId, productType, memberType, tags, ageFrom, ageTo
        } = this.selectedRego;

        const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === memberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && _.isEqual(r.tags, tags)
                                && r.memberType === memberType);
        if (foundRego) {
          this.$store.commit('loading', false);
          return this.$message.error('Registration for this member has already been added to cart.');
        }

        // check if member register to club membership before
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        if (!this.memberMembership) {
          const response = await this.getMemberMembership(memberId);
          this.memberMembership = response.data.data;
        }
        if (this.selectedRego.isClubMembership && this.selectedRego.memberType === 'player' && this.memberMembership) {
          const foundClubMembership = this.memberMembership.filter((rego) => rego.isClubMembership && rego.expired !== true && rego.memberType === 'player' && _.get(rego, 'orgtree.club._id') !== _.get(this.selectedRego, 'orgtree.club._id'));
          console.log({
            selectedRego: this.selectedRego,
            memberMembership: this.memberMembership,
            foundClubMembership
          });
          if (foundClubMembership.length) {
            const registeredMembership = foundClubMembership.find((club) => _.get(club, 'regoEntity.products._id') === _.get(this.selectedRego, 'products[0]._id')
            && club.entityId === this.selectedRego._id
            && club.memberId === memberId);
            if (registeredMembership) {
              this.$store.commit('loading', false);
              return this.$message.error('You have already registered to this club.');
            }
            await this.checkRequestClearances(memberId);
            this.$store.commit('loading', false);
          } else {
            const foundClubMembershipinCart = registrations.find((r) => r.isClubMembership);
            if (foundClubMembershipinCart) return this.$message.error('There is already a club membership in your cart, you can only buy one at a time .');
            this.$store.commit('loading', false);
            const member = this.members.find((m) => m._id === memberId);
            const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
            this.$router.push({
              name: pathName,
              params: {
                criteria: this.criteria, memberId, member, selectedMembership: this.selectedRego
              },
            }).catch((error) => {
              if (
                error.name !== 'NavigationDuplicated'
                && !error.message.includes('Avoided redundant navigation to current location')
              ) {
                console.log(error);
              }
            });
          }
        } else {
          this.$store.commit('loading', false);
          console.log('this memberssss', this.member);
          const member = this.members.find((m) => m._id === memberId);
          const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
          this.$router.push({
            name: pathName,
            params: {
              criteria: this.criteria, memberId, member, selectedMembership: this.selectedRego
            },
          }).catch((error) => {
            if (

              error.name !== 'NavigationDuplicated'
                && !error.message.includes('Avoided redundant navigation to current location')
            ) {
              console.log(error);
            }
          });
        }
      }
      return 0;
    },
    get: _.get,
    trim: _.trim,
    onCartClick() {
      const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
      if (this.cartCount > 0) this.$router.push({ name: pathName });
    },
    closeAndClearFilters() {
      this.filters.memberTypes = [];
      this.filters.registrationTypes = [];
      this.filters.tags = [];
      this.filters.organisationId = undefined;
      doSearch(this, this.criteria, this.filters, this.defaultEntity);
      this.filtersModalVisible = false;
    },
    applyFilters() {
      doSearch(this, this.criteria, this.filters, this.defaultEntity);
      this.filtersModalVisible = false;
    },
    checkUpgradeElegible(rego) {
      const regoId = rego._id;
      const regoProductId = rego.products[0]._id;
      const foundProducts = [];
      if (this.memberMembership) {
        // eslint-disable-next-line no-restricted-syntax
        for (const membership of this.memberMembership) {
          console.log(_.get(membership, 'regoEntity.products.upgradeableMembershipList'), '_.get(membership, \'regoEntity.products.upgradeableMembershipList\')');
          if (_.get(membership, 'regoEntity.products.upgradeableMembershipList') && !membership.expired) {
            // eslint-disable-next-line no-restricted-syntax
            for (const um of membership.regoEntity.products.upgradeableMembershipList) {
              if (um._id === regoId) {
                const foundProduct = um.products.find((product) => product._id === regoProductId);
                if (foundProduct) {
                  foundProducts.push(foundProduct);
                }
              }
            }
          }
        }
      }
      return !!foundProducts.length;
    },
    getCapAndViceCap(value, rego) {
      const tempObj = this.teamDetails;
      tempObj[rego._id] = {
        captain: {
          name: undefined,
        },
        viceCaptain: {
          name: undefined
        },
      };

      const teamDetail = rego.teams.find((team) => team._id === value);

      if (_.get(teamDetail, 'meta.captain')) tempObj[rego._id].captain = _.get(teamDetail, 'meta.captain');
      if (_.get(teamDetail, 'meta.viceCaptain')) tempObj[rego._id].viceCaptain = _.get(teamDetail, 'meta.viceCaptain');
    },
    checkFamily(rego) {
      this.familyMSList = _.get(rego, 'products[0].familyMS');
      _.forEach(this.familyMSList, (fms) => {
        // eslint-disable-next-line no-param-reassign
        fms.availableMembers = this.getAvailableMembers(fms);
      });
      this.familyMSDialog = true;
    },
    getAvailableMembers(product) {
      const members = _.filter(this.members, (member) => {
        const endOfYear = this.$store.getters['national/endOfYear'];
        const memberAge = calculateMemberAge(member.profile.dob, endOfYear);

        return (memberAge >= product.ageFrom && memberAge <= product.ageTo) && (product.gender === member.profile.gender || product.gender === 'All' || (product.gender === 'Other' && (member.profile.gender !== 'Male' || member.profile.gender !== 'Female')));
      });

      // required memberships
      const requiredMSProducts = _.map(this.selectedRego.products[0].membershipProductsRequired, (ms) => ms.products._id);

      const mappedMembers = [];

      if (requiredMSProducts && requiredMSProducts.length) {
        _.forEach(members, (member) => {
          const mappedProductId = _.map(member.registration, (rego) => rego.productId);
          const intersection = _.intersection(requiredMSProducts, mappedProductId);
          if (intersection.length === requiredMSProducts.length) mappedMembers.push(member);
        });
      }
      return _.get(this, 'selectedRego.products[0].isMembershipRequired') ? mappedMembers : members;
    },
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    selectedMember() {
      const hasSelected = _.every(this.familyMSList, (fm) => fm.memberId !== undefined);

      return hasSelected;
    },
    cartCount() {
      return this.$store.getters['cart/counts'];
    },
    userId() {
      return this.$store.getters['user/userId'];
    },
    nationalLogoMark() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_MARK && process.env.VUE_APP_LOGO_MARK !== '' ? process.env.VUE_APP_LOGO_MARK : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Mono_Positive.png');
    },
    nationalLogoOnly() {
      // eslint-disable-next-line global-require
      return process.env.VUE_APP_LOGO_ONLY && process.env.VUE_APP_LOGO_ONLY !== '' ? process.env.VUE_APP_LOGO_ONLY : require('@/assets/logos/mark/Assemble_Logo_Mark_RGB_Mono_Positive.png');
    },
    sortedRegistration() {
      return _.orderBy(this.registrations, (rego) => (rego.isClubMembershipRegoOpen !== undefined ? rego.isClubMembershipRegoOpen : rego.isRegoOpen),
        ['desc']);
    },
    getTitle() {
      return this.memberClearanceRequest
        ? 'Registration unavailable'
        : 'Registration Clearance Request';
    },
    timezone() {
      return this.$store.getters['national/timezone'];
    }
  },
  filters: {
    formatDate(val) {
      return moment(val).format('DD MMM YYYY');
    },
    cap(val) {
      return _.capitalize(val);
    },
    joinTag(val) {
      return _.join(_.map(val, (v) => v.name), ', ');
    },
    parseEventId(val) {
      return `${val.eventId}-${val.productType}-${val.memberType}`;
    },
    parseProductType(val) {
      if (val === 'indv') return 'Individual';
      if (val === 'team') return 'Team';
      if (val === 'indv-to-team') return 'Individual To Team';
      if (val === 'family') return 'Family';
      if (val === 'entity') return 'Entities';
      return 'unknown';
    }
  }
};
</script>

<style scoped lang="scss">

.search-bar-team{
  border: 1px solid #aaaaaa;
        border-radius: 3px;
        // width: 100%;
        display: flex !important;
        justify-content: flex-start;
        text-align: start;
        width: 100%;
        margin-top:1rem
}

::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  th {
    background: #f6f8fa !important;
    padding-right: 1em;
    text-align: left;
  }

  td {
    background-color: white !important;
    padding-top: 1em;
    text-align: left;
  }
}
.uppercase {
  text-transform: uppercase;
}

::v-deep .input-field .el-input__inner{
  padding-left: 2.5rem !important
}

::v-deep .el-dialog {
  max-width: 53em;
}

::v-deep .el-dialog__body {
  padding: 0;
  display: flex;
  flex-direction: column;
}
.p-relative {
  position: relative;
}

.description-text-limit {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main-content {
  width: 100%;
  max-width: $md;
  .input-field{
    background: #FFFFFF;
    border: 0.5px solid rgba(45, 58, 69, 0.3);
    box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
    border-radius: 6px;

  }
  .filter-btn {
    background-color: white;
    border: 2px solid #EF6563;

  }
}

.card-container {
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  //  height: 100%;

  .el-col {
    margin-bottom: 1.5em;
  }

  .entity-card {
    padding: 1em;
    flex-basis: 32.15%;
    background: #FFFFFF;
    border: 0.5px solid rgba(45, 58, 69, 0.3);
    box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
    border-radius: 6px;
    margin: 0.6rem 0.6rem 0 0;

    @media only screen and (max-width: $sm) {
      & {
        flex-basis: 48.5%;
        margin: 0 auto;
        margin-bottom: 1rem;
      }
    }

    @media only screen and (max-width: 450px) {
      & {
        flex-basis: 98%;
        margin: 0 auto;
        margin-bottom: 1rem;
      }
    }

    ::v-deep .el-card__body {
      padding: 0.5em;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
    }
    .event-heading{
      display:flex;
      justify-content: space-between;

      .header-tag{
        max-height: 2.4rem;
        .rego-type {
        right:1%;
        top: 0%;
        font-size: 1.25rem;
        color: #FFF;
        padding: 8px;
        border-radius: 2px;
        text-align: center;
        background: $secondary;
        border-radius: 6px;
        padding: 0.4rem 1.1rem;
        //  box-shadow: 0px 1px 2px rgba(52, 58, 58, 0.6);
        box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
        }
      }

      .outer{
      border-radius: 100%;
      background-color: #EFF0F3;
      width: 80px;
      height: 80px;
      .inner1 {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        background-color: white;
        box-shadow: 0px 1px 2px rgba(52, 58, 58, 0.6);
      }
        .inner{
          width: 35px;
          height: 35px;
          transform:scale(1.5);
          border-radius: 100%;
          background-color: white;
        }
    }

    }

    .event-info {
      position:relative;
      .name {
        flex: 0 0 auto;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 1.4rem;
        font-weight: 500px !important;
        line-height: 1.4rem;
        color: #333F52;
        margin-bottom: 0.3em;

      }
      .team-name{
        background: #FFFFFF;
        box-shadow: 0px 1px 2px rgba(52, 58, 58, 0.6);
        border-radius: 6px;
        padding: 5px 10px;
        font-style: normal;
        font-weight: bold;
        font-size: 1.25rem;
        color: #333F52;
      }
      .entity {
        display: inline;
        font-style: normal ;
        font-weight: normal;
        font-size: 1.1rem;
        line-height: 17px;
        color: #919CAE;
      }

      .description {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        font-size: 0.95em;
        flex: 1 1 auto;
        color: #333F52;

        .member-style{
          background: #FFFFFF;
          //  box-shadow: 0px 1px 2px rgba(52, 58, 58, 0.6);
          border-radius: 6px;
          padding: 0.25rem 0.8rem;
          font-style: normal;
          font-weight: bold;
          font-size: 1.25rem;
          line-height: 1.3rem;
          color: #333F52;
          margin-left:0.4rem;
          border: 0.5px solid rgba(45, 58, 69, 0.3);
          box-shadow: 0px 3px 6px rgba(233, 233, 233, 0.5);
          letter-spacing: 0.01rem;
        }

          .des1{
            font-style: normal;
            font-size: 1.45rem;
            line-height: 1.45rem;
            color: #333F52;
            padding-bottom: 0.5em;
            margin-bottom: 0.8rem;

          }

        .title {
          font-weight: bold;
          margin-right: 0.3em;
          // color: $primary;
        }

        .tags {
            .tag-items{
              position: relative;
              background: rgba($secondary, 0.1);
              display: inline-block;
              word-wrap: break-word;
              font-size: .9rem;
              border-radius: 4px;
              padding-left: 3rem !important;
              //  box-shadow: 0px 1px 2px rgba(52, 58, 58, 0.6);

              .ribbon-tag{
                position: absolute;
                width : 16.5px;
                height:23px;
                left: 1em;
                top: -3px;
                filter: drop-shadow(1px 2px 1px rgba(82, 81, 81, 0.5));
                background: $highlight;
                border-top-right-radius: 2px;
                z-index: 1;
                clip-path: polygon(0 0, 100% 0,
                100% 100%, 96% 100%,
                64% calc(100% - 4.6px),
                63% calc(100% - 4.6px),
                62% calc(100% - 4.8px),
                60% calc(100% - 4.9px),
                58% calc(100% - 4.9px),
                54% calc(100% - 4.8px),
                53% calc(100% - 4.6px),
                52% calc(100% - 4.6px),
                22% 100%, 0% 100%);
              }
              .ribbon-cover{
                position: absolute;
                width: 2.8px;
                height: 25px;
                left:  1em;
                top:  -3px;
                border-top-right-radius: 2px;
                z-index: 2;
                background:lighten($secondary,38%);
                border: none;
              }
              .ribbon-curve{
                position: absolute;
                width: 2.8px;
                height: 3px;
                left:  1em;
                top: -3px;
                border-top-left-radius: 2px;
                border-top-right-radius: 2px;
                z-index: 2;
                background: rgba($highlight, 0.3);
              }
              .ribbon-button{
                position: absolute;
                width: 3px;
                height: 3px;
                left:  1.58em;
                top:  5.2px;
                border-radius: 100%;
                z-index: 3;
                background:white;
              }
            }

        }
      }
    }

    .event-btn {
      padding-top: 1em;
      border-top: 1px solid #EBEEF5;

      .register {
        width: 100%;
        max-width: 32em;
        background: var(--highlight-color);
        color: var(--text-color-primary);
        border-radius: 4px;
        // border-color: var(--highlight-color);
        height: 2.8em;
        font-size: 1.4rem;
      }

      .closed-register{
        width: 100%;
        max-width: 32em;
        background: var(--highlight-color);
        color: var(--text-color-primary);
        // border color up tone 20%

        opacity: 0.7;
        border-radius: 4px;
        height: 2.8em;
        font-size: 1.4rem;
      }
    }
  }
}

.modal-entity-card {
  .event-info {
    .name {
      flex: 0 0 auto;
      // color: $primary;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .entity {
      color: #34647f;
    }

    .description {
      font-size: 0.95em;
      flex: 1 1 auto;
      color: #25485b;

      .title {
        font-weight: bold;
        margin-right: 0.3em;
        // color: $primary;
      }
    }
  }
}
</style>
